<template>
    <submenu-page
        eyebrow="STUDENT PORTAL"
        title="Report"
        description="Review report cards and results from mock examinations."
        count-label="report tools"
    >
        <Submenu />
    </submenu-page>
</template>

<script>
import Submenu from './Menu.vue';
export default {
    components: {
        Submenu
    },
    data() {
        return {
            accessDetails: null,
        };
    },
    mounted() {
         this.accessDetails = this.$store.getters['auth/_user'];
        if (!(this.accessDetails.isSchoolStudent == false || this.accessDetails.isStudentGuardian == false)) {
            this.$store.dispatch('auth/Logout')
            this.$router.push('/login')
        }
    }
};
</script>

<style></style>
